import { render } from "./WarningContainer.vue?vue&type=template&id=472c8e94&scoped=true"
import script from "./WarningContainer.vue?vue&type=script&lang=js"
export * from "./WarningContainer.vue?vue&type=script&lang=js"

import "./WarningContainer.vue?vue&type=style&index=0&id=472c8e94&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-472c8e94"]])

export default __exports__